import React, { Component } from 'react';
import autoBind from 'react-autobind';
import TableHelper from 'src/utils/table-helper';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorMessage from 'src/components/misc/error-message';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Entities } from 'src/common';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';

import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';
import { Toggle } from 'material-ui';

class CancellationsOverviewAdministrations extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
            fromDate: moment().startOf('month').toDate(),
            toDate: moment().toDate(),
            excludeSaleIntegrations: true,
        };
    }

    componentWillMount() {
        this.props.fetchAllCustomRepository(Entities.CANCELLATION_INFOS, 'find-infos', this.getQueryParams());
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.tableHelper.processPaginationAfterUpdate(prevProps.cancellations, this.props.cancellations, this.table)
        )
            this.setState({ renderSelection: !this.state.renderSelection });

        if (
            prevState.fromDate !== this.state.fromDate ||
            prevState.toDate !== this.state.toDate ||
            prevState.excludeSaleIntegrations !== this.state.excludeSaleIntegrations
        ) {
            this.props.fetchAllCustomRepository(Entities.CANCELLATION_INFOS, 'find-infos', this.getQueryParams());
        }
    }

    getQueryParams() {
        const queryParams = [];
        if (this.state.fromDate && this.state.toDate) {
            queryParams.push(`fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}`);
            queryParams.push(`toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`);
        }

        queryParams.push(`excludeSaleIntegrations=${this.state.excludeSaleIntegrations}`);

        return queryParams.join('&');
    }

    componentWillReceiveProps(nextProps) {
        const { cancellations } = nextProps;

        if (cancellations.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(cancellations.items.length);
    }

    render() {
        const { cancellations, t } = this.props;

        const finishFetching = this.state.startedFetching && !cancellations.isFetching;
        const tableData = [];

        if (finishFetching && cancellations.items.length > 0) {
            cancellations.items.map(cancellation => {
                tableData.push({
                    createdAt: cancellation.createdAt,
                    id: cancellation.id,
                    cancelledAt: moment(cancellation.cancelledAt).format(),
                    cancelledByType: cancellation.cancelledByType,
                    cancellationOption: this.getTranslatedOption(cancellation.cancellationOption),
                    optionalCancelTextCustomer: cancellation.optionalCancelTextCustomer,
                    operator: cancellation.task.company.companyName,
                    taskPrice: `${cancellation.task.price.amount} ${cancellation.task.price.currency}`,
                    taskIdentifier: cancellation.task.identifier,
                    bookingIdentifier: cancellation.task.bookingIdentifier,
                });
            });
        }
        return (
            <>
                <legend className="legend">{t('cancellations.title')}</legend>

                {(() => {
                    if (!finishFetching) return <CircularProgress />;
                    else if (cancellations.error) return <ErrorMessage object={cancellations} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign(
                                        { toolBar: this.createCustomToolBar },
                                        this.tableHelper.getOptions(finishFetching),
                                    )}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        width="50"
                                        isKey={true}
                                        dataSort={true}
                                        export={true}>
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="taskIdentifier"
                                        width="100"
                                        dataSort={true}
                                        export={true}>
                                        {t('common_phrases.task_id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="bookingIdentifier"
                                        dataSort={true}
                                        width="100"
                                        export={true}>
                                        {t('common_phrases.booking_id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="cancelledAt"
                                        width="150"
                                        export={true}>
                                        {t('cancellations.cancelled_at')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="cancellationOption"
                                        width="320"
                                        dataSort={true}>
                                        {t('cancellations.reason')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="optionalCancelTextCustomer"
                                        dataSort={true}>
                                        {t('cancellations.customer_comment')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="cancelledByType"
                                        width="100"
                                        dataSort={true}>
                                        {t('cancellations.cancelled_by')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="operator"
                                        dataSort={true}>
                                        {t('common_phrases.company')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="taskPrice"
                                        width="150"
                                        dataSort={true}>
                                        {t('task_details.price')}
                                    </TableHeaderColumn>
                                    {/*<TableHeaderColumn*/}
                                    {/*    dataField="actions"*/}
                                    {/*    width="70"*/}
                                    {/*    dataFormat={this.tableActionsFormatter}*/}
                                    {/*    export={false}>*/}
                                    {/*    {t('common_phrases.actions')}*/}
                                    {/*</TableHeaderColumn>*/}
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </>
        );
    }

    createCustomToolBar(props) {
        const { t } = this.props;
        const { isFetching } = this.props.cancellations;

        return (
            <>
                <div className="col-md-12">
                    <div className="col-md-3">
                        <Toggle
                            label={t('cancellations.filter.exclude_sales_integrations')}
                            toggled={this.state.excludeSaleIntegrations}
                            onToggle={() => {
                                this.setState({ excludeSaleIntegrations: !this.state.excludeSaleIntegrations });
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <div>
                                <DatePicker
                                    value={this.state.fromDate}
                                    container="inline"
                                    disabled={isFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.from.title')}
                                    onChange={(_event, value) => this.setState({ fromDate: value })}
                                    maxDate={this.state.toDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 7 }}
                                />
                            </div>
                            <div>
                                <DatePicker
                                    value={this.state.toDate}
                                    container="inline"
                                    disabled={isFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.to.title')}
                                    onChange={(_event, value) => this.setState({ toDate: value })}
                                    minDate={this.state.fromDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 30 }}
                                />
                            </div>

                            <div
                                style={{
                                    width: 400,
                                    marginRight: 6,
                                    marginTop: 34,
                                    marginLeft: 'auto',
                                }}>
                                {props.components.searchPanel}
                            </div>
                        </div>
                        <div style={{ marginRight: 'auto' }}>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                    if (this.table) {
                                        this.table.handleExportCSV();
                                    }
                                }}>
                                {t('common_phrases.export_list')}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    getTranslatedOption(option) {
        if (option && option.description.de) return option.description.de;
        return '';
    }
}

export default withTranslation()(composeModalActions(CancellationsOverviewAdministrations));
